<template>
  <nav v-scroll class="d-flex justify-content-between align-items-center p-3 bg-light-subtle fixed-top">
    <!-- Nom ou logo -->
    <div class="mx-4">
      <router-link to="/">Pablo Cirès</router-link>
    </div>

    <!-- Conteneur pour les titres (centré) -->
    <div class="d-none d-lg-flex d-flex justify-content-center flex-grow-1">
      <router-link to="/film/1" class="mx-4">Mamma</router-link>
      <router-link to="/film/2" class="mx-4">Arcobaleno</router-link>
    </div>

    <!-- Icône burger & Réseaux sociaux -->
    <div class="d-flex align-items-center mx-4">
      <a
        href="https://www.instagram.com/p__cires/"
        target="_blank"
        class="d-flex align-items-center me-3 d-lg-block"
      >
        <i class="bi bi-instagram"></i>
      </a>
      <!-- Bouton burger -->
      <button
        class="btn p-0 d-lg-none"
        @click="toggleMenu"
        aria-label="Toggle navigation"
      >
        <i class="bi bi-list" style="font-size: 1.8rem;"></i>
      </button>
    </div>

    <!-- Menu mobile (affiché lors du clic sur l'icône burger) -->
    <div v-if="menuOpen" class="mobile-menu bg-light shadow">
      <router-link
        to="/film/1"
        class="d-block py-2"
        @click="closeMenu"
      >
        Mamma
      </router-link>
      <router-link
        to="/film/2"
        class="d-block py-2"
        @click="closeMenu"
      >
        Arcobaleno
      </router-link>
      <router-link
        to="/contact"
        class="d-block py-2"
        @click="closeMenu"
      >
        Contact
      </router-link>
    </div>

    <!-- Conteneur pour "Contact" aligné à droite -->
    <div class="d-none d-lg-flex ms-auto">
      <router-link v-if="!menuOpen" to="/contact" class="mx-4">Contact</router-link>
    </div>
  </nav>
</template>


<script>
export default {
  name: "HeaderComponent",
  data() {
    return {
      menuOpen: false, // Contrôle de l'affichage du menu mobile
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false; // Fermer le menu
    },
  },
};
</script>

<style scoped>
/* Styles généraux */
a {
  color: black;
  text-decoration: none;
}

.bi-instagram {
  color: #e1306b; /* Couleur Instagram */
  font-size: 1.6rem;
  transition: transform 0.4s;
}

.bi-instagram:hover {
  transform: scale(1.1);
}

/* Menu mobile */
.mobile-menu {
  position: absolute;
  top: 77px; /* Ajuster selon la hauteur de la navbar */
  right: 10px;
  z-index: 1000;
  border-radius: 8px;
  padding: 10px;
  width: calc(100% - 20px); /* Largeur ajustable */
}



.d-none.d-lg-flex .ms-auto {
  margin-left: auto; /* Aligne "Contact" à droite sur desktop */
}

@media (max-width: 992px) {
  .mobile-menu {
    left: 10px;
  }
}
</style>
